import * as React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTheme } from "@emotion/react";
import { useStyles } from "../theme/style";

export default function Popup({
  fullWidth,
  maxWidth,
  title = '',
  contentText,
  content,
  open,
  setOpen,
  backdropClickDisabled,
  disableEscapeKeyDown,
  showExpandBtn = true,
  customProps = {
    contentTextSize : "16px",
    contentTextFontWeight: "None"
  }
}) {
  const theme = useTheme();
  const classes = useStyles(theme);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") {
      if (backdropClickDisabled == true) {
        return;
      }
    }
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        disableEscapeKeyDown={disableEscapeKeyDown}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
        scroll={"paper"}
      >
        <DialogTitle sx={{ fontFamily: theme.typography["fontFamily"] }}>
          {title}
          <Icon
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 10,
              color: (theme) => theme.palette.grey[500],
              cursor: "pointer",
              fontFamily: theme.typography["fontFamily"],
            }}
          >
            <Close />
          </Icon>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            sx={{ fontFamily: theme.typography["fontFamily"], fontSize: customProps.contentTextSize, fontWeight: customProps.contentTextFontWeight }}
          >
            {contentText}
          </DialogContentText>
          <Box sx={{}}>{content}</Box>
        </DialogContent>
        {showExpandBtn && (
          <DialogActions>
            <Button
              disableRipple
              className={classes.filledButton}
              onClick={handleClose}
            >
              Close
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </React.Fragment>
  );
}
